export default function (state = null, action) {
	switch (action.type) {

	case 'FETCH_SERVICE_SUCCESS':
		return action.response

	case 'UPDATE_SERVICE_SUCCESS':
		return action.response
		
	case 'SWITCH_PLAN_SUCCESS':
		return action.response


	case 'LOGOUT':
		return null
	
	default:
		return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/service.js